module.exports = __webpack_public_path__ + "assets/hamburger-b12a59.svg";